import React from 'react';
import { Outlet } from 'react-router-dom';

const TransitionLayout: React.FC = () => <Outlet />;

export default TransitionLayout;
